import { ReactComponent as FacebookIcon } from 'icons/social/facebook.svg';
import { ReactComponent as TwitterIcon } from 'icons/social/twitter.svg';
import { ReactComponent as InstagramIcon } from 'icons/social/instagram.svg';
import { ReactComponent as SpotifyIcon } from 'icons/social/spotify.svg';
import { ReactComponent as YoutubeIcon } from 'icons/social/youtube.svg';

import { ReactComponent as FacebookSelectedIcon } from 'icons/socialWhite/facebook.svg';
import { ReactComponent as InstagramSelectedIcon } from 'icons/socialWhite/instagram.svg';
import { ReactComponent as SpotifySelectedIcon } from 'icons/socialWhite/spotify.svg';
import { ReactComponent as TwitterSelectedIcon } from 'icons/socialWhite/twitter.svg';
import { ReactComponent as YoutubeSelectedIcon } from 'icons/socialWhite/youtube.svg';

import { ReactComponent as AppleMusic } from 'icons/playlistDsp/appleMusic.svg';
import { ReactComponent as SelectedAppleMusic } from 'icons/playlistDsp/appleMusic-white.svg';

export const tableHeaders = [
  {},
  {
    label: 'This Week to Date',
    value: 'performanceThisWeekToDate',
  },
  {
    label: 'Last Full Week',
    value: 'countLastWeek',
  },
  {
    label: 'Release to Date',
    value: 'releaseDate',
  },
  {},
];

export const socialIcons = {
  facebook: {
    main: FacebookIcon,
    selected: FacebookSelectedIcon,
  },
  twitter: {
    main: TwitterIcon,
    selected: TwitterSelectedIcon,
  },
  instagram: {
    main: InstagramIcon,
    selected: InstagramSelectedIcon,
  },
  spotify: {
    main: SpotifyIcon,
    selected: SpotifySelectedIcon,
  },
  youtube: {
    main: YoutubeIcon,
    selected: YoutubeSelectedIcon,
  },
  apple: {
    main: AppleMusic,
    selected: SelectedAppleMusic,
  },
};
